export default function (to, from, next) {
    const aclid = to.query.aclid || from.query.aclid;

    if(aclid){
        try{
            localStorage.setItem('advertising.lastAclid', aclid);
        }catch(e){/*DO nothing*/}
    }

    return next();
}